import { GlobalStyles, UncaughtErrorPage } from '@lbcamden/lib-react';
import { AppInsightsErrorBoundary } from '@microsoft/applicationinsights-react-js';
import { FunctionComponent } from 'react';
import { Outlet } from 'react-router';

import { AppProviders } from './AppProviders';
import { PageTitle } from './components/common/PageTitle';
import { AppContainer } from './components/containers/AppContainer';
import { AppToolbar } from './components/shared/AppToolbar';
import { ClientAuthOverlay } from './components/shared/ClientAuthOverlay';
import { DataSyncOverlay } from './components/shared/DataSyncOverlay';
import { reactPlugin } from './lib/appInsights';

export const App: FunctionComponent = () => (
  <AppInsightsErrorBoundary onError={UncaughtErrorPage} appInsights={reactPlugin}>
    <AppProviders>
      <GlobalStyles />
      <PageTitle />
      <AppContainer>
        <AppToolbar />
        <Outlet />
      </AppContainer>
      <ClientAuthOverlay />
      <DataSyncOverlay />
    </AppProviders>
  </AppInsightsErrorBoundary>
);
